var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-progress-linear", {
                attrs: { indeterminate: "", color: "blue darken-2" },
              }),
              _c("v-card-text", [
                _c(
                  "div",
                  [
                    _c(
                      "v-container",
                      { staticStyle: { height: "20px" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "fill-height",
                            attrs: {
                              "align-content": "center",
                              justify: "center",
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "subtitle-1 text-center",
                                attrs: { cols: "12" },
                              },
                              [_vm._v(" " + _vm._s(_vm.text) + " ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }